import React from 'react'
import { Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Col, Row } from 'reactstrap';
import Select from 'react-select';



export const ModalSpecialDiscount = (props) => {

    const {
        modal, toggle, special_discount_code, handleInputChangeSpecialDiscount, validateCodeSpecialDiscount, validatePercentajeSpecialDiscount, percentage,
        validPorcentejeSpecial, dataPreloaded, handleSelectValuesPreloadedDiscounts, id_preloaded_discount, validatePreloadedDiscount,
        id_branch, new_price, validatePriceWorkOrder
    } = props;


    return (
        <Modal isOpen={modal} toggle={toggle} backdrop='static' keyboard={false} centered={true} size='lg' style={{ width: '580px' }}>
            <ModalHeader toggle={toggle} className="bg-primary" style={{ textAlign: "center" }}> Descuentos Especiales </ModalHeader>
            <ModalBody>
                <Col sm="12">
                    <Row>
                        <Col sm="6" className='p-1' >
                            <Form role="form">
                                <FormGroup className="col-12">
                                    <Label className='f-w-600 f-12 badge badge-light-primary'>Ingresa el código de descuento</Label>
                                    <Input
                                        name="special_discount_code"
                                        value={special_discount_code}
                                        required={true}
                                        onChange={handleInputChangeSpecialDiscount}
                                        style={{ textTransform: "uppercase" }}
                                        className='form-control form-control-sm input-air-primary'
                                    />
                                </FormGroup>
                            </Form>
                        </Col>

                        <Col sm="6"> <br />  <br />
                            <Button size='sm' utline color="secondary" type="button" onClick={validateCodeSpecialDiscount}>Aplicar descuento especial</Button>
                        </Col>
                    </Row>
                </Col>
                <Col sm="12" className={(validPorcentejeSpecial === "https://labcen.helen-sw.com" || validPorcentejeSpecial === "https://hsjs.helen-sw.com" || validPorcentejeSpecial === "https://almass.helen-sw.com" || validPorcentejeSpecial === "https://insan.helen-sw.com" || validPorcentejeSpecial === "https://phersu.helen-sw.com" || validPorcentejeSpecial === "https://arcangeles.helen-sw.com") ? "" : "d-none"}>
                    <Row>
                        <Col sm="6" className='p-1' >
                            <Form role="form">
                                <FormGroup className="col-12">
                                    <Label className='f-w-600 f-12 badge badge-light-primary'>Ingresa el porcentaje de descuento</Label>
                                    <Input
                                        name="percentage"
                                        value={percentage}
                                        onChange={handleInputChangeSpecialDiscount}
                                        style={{ textTransform: "uppercase" }}
                                        className='form-control form-control-sm input-air-primary'
                                    />
                                </FormGroup>
                            </Form>
                        </Col>


                        <Col sm="6"> <br /> <br />
                            <Button size='sm' outline color="primary" type="button" onClick={validatePercentajeSpecialDiscount}>Aplicar porcentaje especial</Button>
                        </Col>
                    </Row>
                </Col>
                <Col sm="12" className={validPorcentejeSpecial === "https://pyrsa.helen-sw.com" || validPorcentejeSpecial === "https://cedimi.helen-sw.com" || validPorcentejeSpecial == "https://demolis-lis.helen-sw.com" ? " " : "d-none"} >
                    <Label className='f-w-600 f-12 badge badge-light-primary'>Selecciona el tipo de descuento</Label>
                    <Col sm="12" className='p-l-0' >
                        <Row>
                            <Col sm="6" >
                                <Select
                                    classNamePrefix="select"
                                    name="id_preloaded_discount"
                                    value={id_preloaded_discount}
                                    options={dataPreloaded}
                                    onChange={(e) => handleSelectValuesPreloadedDiscounts(e, "id_preloaded_discount")}
                                    placeholder="Selecciona un descuento"
                                    isClearable={true}
                                    menuPlacement="top"
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            fontSize: '11px',
                                        }),
                                        menuPortal: (base) => ({ ...base, zIndex: 99999 })
                                    }}


                                />
                            </Col>
                            <Col sm="6" className='pt-1' >
                                <Button size='sm' utline color="warning" type="button" onClick={() => validatePreloadedDiscount()}>Aplicar descuento especial</Button>
                            </Col>
                        </Row>

                    </Col>
                </Col>
                {
                    // ? SPECIAL DISCOUNT
                }
                <Col sm="12" className={(validPorcentejeSpecial === "https://insan.helen-sw.com" && id_branch === "10") ? "" : "d-none"}>
                    <Row>
                        <Col sm="6" className='p-1' >
                            <Form role="form">
                                <FormGroup className="col-12">
                                    <Label className='f-w-600 f-12 badge badge-light-primary'>Ingresa el monto total de la orden</Label>
                                    <Input
                                        name="new_price"
                                        value={new_price}
                                        onChange={handleInputChangeSpecialDiscount}
                                        style={{ textTransform: "uppercase" }}
                                        className='form-control form-control-sm input-air-primary'
                                    />
                                </FormGroup>
                            </Form>
                        </Col>


                        <Col sm="6"> <br /> <br />
                            <Button size='sm' outline color="primary" type="button" onClick={validatePriceWorkOrder}>Aplicar precio final de la venta</Button>
                        </Col>
                    </Row>
                </Col>
            </ModalBody>
            <ModalFooter>
                <Button outline color="danger" type="button" onClick={toggle}>Cerrar visualización</Button>
            </ModalFooter>
        </Modal>
    )
}

